import { useMemo } from "react";
import {
  allowedPlatformFullnameMapping,
  allowedSelectCoverPlatforms,
  allowedUploadCoverPlatforms,
} from "../const";

interface Platform {
  TYPE: string;
  NAME: string;
}

interface UsePlatformPermissionsProps {
  selectedPlatform: string;
  platforms: Platform[];
  videoLoadingError?: boolean;
  videoUrl?: string;
}

export function usePlatformPermissions({
  selectedPlatform,
  platforms,
  videoLoadingError,
  videoUrl,
}: UsePlatformPermissionsProps) {
  const allowUpload = useMemo(() => {
    if (videoLoadingError) {
      return true;
    }

    if (!videoUrl) {
      return false;
    }

    return allowedUploadCoverPlatforms.includes(selectedPlatform);
  }, [videoLoadingError, videoUrl, selectedPlatform]);

  const displayPlatforms = useMemo(
    () =>
      platforms.filter((platform) =>
        allowedSelectCoverPlatforms.includes(platform.TYPE)
      ),
    [platforms]
  );

  const platformFullname = useMemo(
    () => allowedPlatformFullnameMapping[selectedPlatform] || "",
    [selectedPlatform]
  );

  const canSelectFrame = useMemo(
    () => allowedSelectCoverPlatforms.includes(selectedPlatform),
    [selectedPlatform]
  );

  return {
    allowUpload,
    displayPlatforms,
    platformFullname,
    canSelectFrame,
  };
}
